import styled, { keyframes } from 'styled-components';

import InputSimple from '@r1-frontend/ui-react/components/inputSimple';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { BoxShadow } from '@r1-frontend/ui-react/tokens/boxShadow';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-16px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const InputAutocompleteContainer = styled(InputSimple)`
    margin-bottom: 0px !important;
`;

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
    flex-direction: column;
`;

export const Suggestions = styled.div`
    position: absolute;
    overflow-y: auto;
    left: 0;
    top: 100%;
    width: 100%;
    max-height: 240px;
    margin-top: -10px;
    box-shadow: ${BoxShadow.M};
    border-radius: ${BorderRadius.componentRadius};
    animation: ${fadeIn} 0.2s ease-in-out;
    z-index: 10;
    background: ${COLORS.BgMain};
`;

export const SuggestionItem = styled.div<{ isActive: boolean }>`
    width: 100%;
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${p => p.isActive ? COLORS.BgSecondary : COLORS.BgMain};
    ${FONTS.XS};
    color: ${COLORS.TextPrimary};
    padding: 8px 30px 8px 20px;
    transition: background-color linear .2s;
    cursor: pointer;
    text-align: left;
    
    &:hover {
        background-color: ${COLORS.BgSecondary};
    }
`;
